<div [ngClass]="{ 'content-panel': !showAll, loading: loading }">
  <div class="recent-transactions__header" #header>
    <air-title [title]="title" [region]="region || contentBlockRegion.primary" [isFirst]="isFirst">
      <a *ngIf="transactionsPage" class="button button--border" [airLink]="transactionsPage._url" [userEventSource]="userEventSource">
        {{ "transactions.label.view_all_transactions" | translate }}
      </a>
      <div class="recent-transactions__filters" *ngIf="!loading && transactions?.length && showAll">
        <div class="recent-transactions__filters-wrapper">
          <form [formGroup]="filterForm" class="transactions__select">
            <select formControlName="transactionType" (change)="transactionTypeSelect()">
              <option *ngFor="let option of transactionTypeOptions" [value]="option.value" [selected]="option.selected">
                {{ option.text }}
              </option>
            </select>
            <i class="icon icon-ui-arrow--down"></i>
          </form>
          <button class="button button--border" (click)="openFilterModal()">
            <span>{{ "transactions.label.other_filters" | translate }}</span>
            <i class="icon icon-ui-filter"></i>
            <div class="button__badge" *ngIf="filtersActive"></div>
          </button>
        </div>
      </div>
    </air-title>
  </div>
  <ng-container *ngIf="loading || filteredTransactions.length > 0; else noTransactions">
    <air-table class="recent-transactions__table" [loading]="loading">
      <air-table-heading
        [sortable]="showAll"
        (headingClick)="sort('date')"
        [sortAsc]="sortKey === 'date' && sortAsc"
        [sortDesc]="sortKey === 'date' && !sortAsc"
      >
        {{ "general.label.date" | translate }}
      </air-table-heading>
      <air-table-heading
        [sortable]="showAll"
        (headingClick)="sort('name')"
        [sortAsc]="sortKey === 'name' && sortAsc"
        [sortDesc]="sortKey === 'name' && !sortAsc"
      >
        {{ "general.label.name" | translate }}
      </air-table-heading>
      <air-table-heading
        [sortable]="showAll"
        (headingClick)="sort('description')"
        [sortAsc]="sortKey === 'description' && sortAsc"
        [sortDesc]="sortKey === 'description' && !sortAsc"
      >
        {{ "general.label.description" | translate }}
      </air-table-heading>
      <air-table-heading
        [sortable]="showAll"
        (headingClick)="sort('points')"
        [sortAsc]="sortKey === 'points' && sortAsc"
        [sortDesc]="sortKey === 'points' && !sortAsc"
      >
        {{ "general.label.air_miles" | translate }}
      </air-table-heading>
      <ng-container air-table-body>
        <tr
          *ngFor="
            let transaction of filteredTransactions
              | paginate: { id: 'pagination--transactions', itemsPerPage: content?.numberOfTransactions, currentPage: page }
          "
        >
          <td>{{ transaction.date | date: "dd-MM-yyyy" }}</td>
          <td>{{ transaction.name }}</td>
          <td>
            {{ transaction.isShared ? ("transactions.label.shared_transaction" | translate) + ": " : "" }}{{ transaction.description }}
          </td>
          <td>
            <div class="sticker-group sticker-group--sm" [ngStyle]="{ visibility: transaction.points !== 0 ? 'visible' : 'hidden' }">
              <div class="sticker sticker--miles sticker--sm" [ngClass]="{ 'sticker--green': transaction.isShared }">
                <span class="sticker__counter">{{ transaction.points | formatNumber: true }}</span>
                <span class="sticker__label">{{ "general.label.air_miles" | translate }}</span>
              </div>
              <div class="sticker sticker--miles-only sticker--sm">
                <span class="sticker__label">{{ transaction.points < 0 ? "&minus;" : "&plus;" }}</span>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </air-table>
    <pagination-controls
      *ngIf="showAll && filteredTransactions && filteredTransactions.length > content.numberOfTransactions"
      id="pagination--transactions"
      class="pagination"
      [directionLinks]="false"
      [autoHide]="true"
      (pageChange)="onPageChange($event)"
    ></pagination-controls>
  </ng-container>
  <ng-template #noTransactions>
    <p *ngIf="transactions?.length && !filteredTransactions?.length">{{ "transactions.label.no_transactions_filtered" | translate }}</p>
    <p *ngIf="!transactions?.length">{{ noTransactionsText }}</p>
  </ng-template>
</div>
